import { ImageLoader } from "@src/helpers/ImageLoader";
import { BackrestLightType } from "@src/saunaparts/BackRestLightType";
import ImageResolution from "@src/saunaparts/ImageResolution";
import { BenchModel } from "@src/saunaparts/BenchModel";
import { LayerImageRepository } from "..";
import {Layer} from "./Layer";

export class BenchBackRestLightLayer implements Layer
{
    bench:BenchModel;
    lightType:BackrestLightType;
    layerImageRepository:LayerImageRepository;
    baseLayer:HTMLCanvasElement;
    constructor(bench:BenchModel,lightType:BackrestLightType,layerImageRepository:LayerImageRepository,baseLayer:HTMLCanvasElement)
    {
        this.bench=bench;
        this.lightType=lightType;
        this.layerImageRepository = layerImageRepository;
        this.baseLayer= baseLayer;
       
    }
    
    Render(desiredResolution: ImageResolution): Promise<HTMLCanvasElement> {
        let imagefile ="";
        switch(this.lightType)
        {
            case BackrestLightType.Fiber:
                imagefile = this.layerImageRepository.getBenchBackrestFiberLightLayer(this.bench,desiredResolution);
            break;   
            case BackrestLightType.LinearBar:
                imagefile = this.layerImageRepository.getBenchBackrestLinearBarLightLayer(this.bench,desiredResolution);
            break; 
        }
        if(imagefile)
        {
            return new ImageLoader(imagefile).Load().then((i)=>{
                let context = this.baseLayer.getContext("2d");
                if(context!=null)
                {
                context.globalCompositeOperation = "lighter";      
                context.drawImage(i,0,0,desiredResolution.width,desiredResolution.height);
                context.globalCompositeOperation= "source-over";
                return this.baseLayer;
                }
                else
                 throw "failed to create context";
            });
        }
        else
        {
            return new Promise((resolve)=> resolve(this.baseLayer));
        }
    }
}